// src/config/config.ts
const env = {
  //開発環境
  //   url: "https://admin.evls-dev.com",
  //   useMock: false,
  //検証環境１
  // url: "https://api.admin.evls-stg1.com",
  // useMock: false,
  //検証環境2
  //   url: "https://admin.evls-stg2.com",
  //   useMock: false,
  //検証環境3
  //   url: "https://admin.evls-stg3.com",
  //   useMock: false,
  //商用環境
  url: "https://api.admin.ouchiev.jpn.panasonic.com",
  useMock: false,
  //ローカル＆機能動作確認用
  // url: "",
  // useMock: true,
};

export default env;
